require('./stylesheet/index.scss');

angular.module('pages.service', [])
	.config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
	$stateProvider
		.state('pages.service', {
			url: 'service/:url',
			templateProvider: ['$stateParams', function($stateParams) {
				if ($stateParams.url === '97033') {
					return require('./templates/index-97033.html');
				} else {
					return require('./templates/index.html');
				}
			}],
			controller: require('./controllers/service.controller'),
			data: {
				iframe: true,
			},
			params: {
				fields: {},
				serviceId: null,
				hh: {
					templateId: null,
					serviceName: null,
					streetName: null
				},
				hhTemplate: false,
				autoCheck: null,
				subscribe: null,
				amount: null,
				counters: null,
				account: null,
				lastDate: null,
				destination: null,
				templateId: null,
				editForbid: false,
				urlCode: null
			},
			pageTrack: '/service'
		})
}

module.exports = 'pages.service';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/service/index.js
 ** module id = 289
 ** module chunks = 1
 **/